import React from "react";
import { useTranslation } from "react-i18next";
import { Menu, Dropdown } from "antd";
import { IconDown2, IconEnglish, IconVietnamese } from "../icons";

const ChangeLanguage = () => {
  const { i18n } = useTranslation("common");
  const handleChangeLanguage = (lang: "vi" | "en") => {
    i18n.changeLanguage(lang);
  };

  const menuLanguage = (
    <Menu selectedKeys={[i18n.language]}>
      <Menu.Item key="vi">
        <button
          className="language__link"
          onClick={() => {
            handleChangeLanguage("vi");
          }}
        >
          <IconVietnamese />
          <span className="ml-16">Tiếng Việt</span>
        </button>
      </Menu.Item>
      <Menu.Item key="en">
        <button
          className="language__link"
          onClick={() => {
            handleChangeLanguage("en");
          }}
        >
          <IconEnglish />
          <span className="ml-16">English</span>
        </button>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="dropdown language">
      <Dropdown
        overlay={menuLanguage}
        trigger={["click"]}
        getPopupContainer={(trigger: any) => trigger.parentNode}
      >
        <button className="dropdown-toggle">
          <div className="flex md:flex-row-reverse items-center gap-8">
            <div>
              {i18n.language === "vi" ? <IconVietnamese /> : <IconEnglish />}
            </div>
            <span>{i18n.language === "vi" ? "Tiếng Việt" : "English"}</span>
          </div>
          <IconDown2 />
        </button>
      </Dropdown>
    </div>
  );
};

export default ChangeLanguage;
